import React, {createContext, useContext, useState} from 'react';

type SurveyErrorContextType = {
  error: string | null;
  setError: (error: string | null) => void;
};

const SurveyErrorContext = createContext<SurveyErrorContextType | undefined>(undefined);

export const SurveyErrorProvider: React.FC<{children: React.ReactNode}> = ({children}) => {
  const [error, setError] = useState<string | null>(null);

  return <SurveyErrorContext.Provider value={{error, setError}}>{children}</SurveyErrorContext.Provider>;
};

export const useSurveyError = () => {
  const context = useContext(SurveyErrorContext);
  if (context === undefined) {
    throw new Error('useSurveyError must be used within a SurveyErrorProvider');
  }
  return context;
};
